export enum OverTimeSettingsType {
    No = 'No',
    MyFac = 'myFac',
    AllFac = 'allFac',
    Yes = 'Yes'
}
